(document.addEventListener('DOMContentLoaded', function () {
    !(function () {
        let e = document.createElement('div'),
            t = document.createElement('div'),
            r = document.createElement('div'),
            n = document.createElement('div');
        if (
            (r.classList.add('progress-container'),
            n.classList.add('progress-bar-fill'),
            t.classList.add('progress-quantity--wrapper'),
            e.classList.add('quantity-selector-discount--wrapper'),
            document.querySelectorAll('.quantity-selector-discounts') &&
                document.querySelectorAll(
                    '[data-block-type="quantity-discount"]'
                ))
        ) {
            let a = document.querySelectorAll(
                    '[data-block-type="quantity-discount"]'
                )[0],
                i = document.querySelectorAll('.quantity-selector-discounts');
            (i.forEach((a, c) => {
                if (
                    (e.appendChild(a),
                    a.querySelector('[name="quantity"]') &&
                        a
                            .querySelector('[name="quantity"]')
                            .addEventListener('click', function (e) {
                                (function (e) {
                                    if (
                                        document.querySelectorAll(
                                            '[data-quantity-input]'
                                        ) &&
                                        e
                                    ) {
                                        if (
                                            (document
                                                .querySelectorAll(
                                                    '[data-quantity-input]'
                                                )
                                                .forEach((t, r) => {
                                                    (t !== e &&
                                                        (t.checked = !1),
                                                        document.querySelectorAll(
                                                            '.quantity-selected'
                                                        ) &&
                                                            e.getAttribute(
                                                                'data-selected'
                                                            ) &&
                                                            (document.querySelectorAll(
                                                                '.quantity-selected'
                                                            )[r].innerHTML =
                                                                e.getAttribute(
                                                                    'data-selected'
                                                                )),
                                                        document.querySelector(
                                                            '.quantity-selected-dose'
                                                        ) &&
                                                            e.getAttribute(
                                                                'data-per-quantity'
                                                            ) &&
                                                            (document.querySelector(
                                                                '.quantity-selected-dose'
                                                            ).innerHTML =
                                                                e.getAttribute(
                                                                    'data-per-quantity'
                                                                )));
                                                }),
                                            document.querySelectorAll(
                                                '.quantity-savings'
                                            ))
                                        ) {
                                            let t =
                                                    document.querySelectorAll(
                                                        '.quantity-savings'
                                                    ),
                                                r = Number(e.value);
                                            t.forEach((e) => {
                                                Number(
                                                    e.getAttribute(
                                                        'data-quantity'
                                                    )
                                                ) <= r
                                                    ? e.classList.add('reached')
                                                    : e.classList.remove(
                                                          'reached'
                                                      );
                                            });
                                        }
                                        if (
                                            document.querySelectorAll(
                                                '.progress-bar-quantity'
                                            )
                                        ) {
                                            let t = document.querySelectorAll(
                                                    '.progress-bar-quantity'
                                                ),
                                                r = Number(e.value);
                                            t.forEach((e) => {
                                                Number(
                                                    e.getAttribute(
                                                        'data-quantity'
                                                    )
                                                ) <= r
                                                    ? setTimeout(() => {
                                                          e.classList.add(
                                                              'reached'
                                                          );
                                                      }, 200)
                                                    : setTimeout(() => {
                                                          e.classList.remove(
                                                              'reached'
                                                          );
                                                      }, 200);
                                            });
                                        }
                                        document.querySelector(
                                            '.progress-bar-fill'
                                        ) &&
                                            (document.querySelector(
                                                '.progress-bar-fill'
                                            ).style.width = `${30 * e.value}%`);
                                    }
                                })(e.target);
                            }),
                    a.querySelector('.progress-quantity'))
                ) {
                    let e = a.querySelector('.progress-quantity');
                    (0 === c
                        ? e.querySelector('.quantity-selected-wrapper') &&
                          e
                              .querySelector('.quantity-selected-wrapper')
                              .classList.remove('hidden')
                        : c === i.length - 1 &&
                          e.querySelector('.quantity-savings') &&
                          (e.querySelector('.quantity-savings').style.right =
                              '5px'),
                        (n.style.width = '30%'),
                        t.appendChild(e),
                        e.querySelector('.progress-bar-quantity') &&
                            r.appendChild(
                                e.querySelector('.progress-bar-quantity')
                            ));
                }
            }),
                r && n && r.appendChild(n),
                t && r && t.appendChild(r),
                a && t && a.appendChild(t),
                a && e && a.appendChild(e));
        }
    })();
}),
    document.addEventListener('variant:change', function (e) {
        if (e.detail.variant.id) {
            var t;
            ((t = e.detail.variant.id),
                document.querySelectorAll('.accordion-details-wrapper') &&
                    document
                        .querySelectorAll('.accordion-details-wrapper')
                        .forEach((e) => {
                            Number(e.getAttribute('data-selected-variant')) ===
                            Number(t)
                                ? e.classList.remove('hidden')
                                : e.classList.add('hidden');
                        }),
                document.querySelectorAll('[priceAfterDiscount]') &&
                    document
                        .querySelectorAll('[priceAfterDiscount]')
                        .forEach((e) => {
                            if (e.checked) {
                                let t =
                                        document.querySelector(
                                            'compare-at-price'
                                        ),
                                    r = document.querySelector('sale-price'),
                                    n = e.getAttribute('originalPrice'),
                                    a = e.getAttribute('priceAfterDiscount');
                                (n == a
                                    ? (t.setAttribute('hidden', ''),
                                      (r.innerHTML = n))
                                    : (t.removeAttribute('hidden'),
                                      (t.innerHTML = n),
                                      (r.innerHTML = a)),
                                    document.querySelector(
                                        '.product-unit-price__inner'
                                    ) &&
                                        e.getAttribute('data-unit-price') &&
                                        (document.querySelector(
                                            '.product-unit-price__inner'
                                        ).innerHTML =
                                            e.getAttribute('data-unit-price')));
                            }
                        }));
        }
    }),
    document.getElementById('sidebar-cart'),
    (window.updateCartQuantity = function (e, t) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: e, quantity: t })
        })
            .then((e) => e.json())
            .then((e) => {
                (console.log('Cart updated:', e),
                    fetch('/cart?view=drawer')
                        .then((e) => e.text())
                        .then((e) => {
                            let t = new DOMParser()
                                .parseFromString(e, 'text/html')
                                .querySelector('.Drawer__Content');
                            t &&
                                (document.querySelector(
                                    '.Drawer__Content'
                                ).innerHTML = t.innerHTML);
                        })
                        .catch((e) => {
                            console.error('Error cart display:', e);
                        }));
            })
            .catch((e) => {
                console.error('Cart update error:', e);
            });
    }),
    window.theme && window.theme.template,
    window.theme && window.theme.pageType,
    Shopify && Shopify.Checkout);
